define("settings/components/integrations/mavely/index", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <section class="tAC--section u--m__t__lg u--m__b__lg">
    <Integrations::Mavely::Profiles @group={{@group}} />
  </section>
  */
  {
    "id": "vBGQV0xy",
    "block": "[[[10,\"section\"],[14,0,\"tAC--section u--m__t__lg u--m__b__lg\"],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@group\"],[[30,1]]],null],[1,\"\\n\"],[13]],[\"@group\"],false,[\"integrations/mavely/profiles\"]]",
    "moduleName": "settings/components/integrations/mavely/index.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});